import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { EshopAPI } from '@twisto/api-cms'

import { EshopCard } from 'homepage/components/eshop-card'
import { useAdditionalData } from 'homepage/libs/context'

import * as styles from './eshops-list.styles'

type EshopsListProps = {
  name?: string
  list?: EshopAPI[]
}

export const EshopsList = ({ list, name }: EshopsListProps) => {
  const { origin } = useAdditionalData()
  if (!list || !list.length) {
    return null
  }

  return (
    <div css={styles.container}>
      {name && (
        <Typography css={styles.name} variant="h3">
          {name}
        </Typography>
      )}

      <div css={styles.shopsWrap}>
        <div css={styles.shops}>
          {list.map((shop) => (
            <EshopCard key={shop.id} origin={origin || ''} shop={shop} />
          ))}
        </div>
      </div>
    </div>
  )
}
